import React from 'react'
import type { TipStatus } from '../types'

const MARKET_CATEGORIES = [
  { value: 'goalscorer', label: 'Goalscorer' },
  { value: 'goals', label: 'Goals' },
  { value: 'corners', label: 'Corners' },
  { value: 'fouls_cards', label: 'Cards' },
  { value: 'shots', label: 'Shots' },
]

const STATUS_OPTIONS: { value: TipStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All Tips' },
  { value: 'active', label: 'Active' },
  { value: 'landed', label: 'Landed' },
  { value: 'missed', label: 'Missed' },
]

const MIN_PROBABILITY_OPTIONS = [
  { value: 55, label: '55%+' },
  { value: 60, label: '60%+' },
  { value: 65, label: '65%+' },
  { value: 70, label: '70%+' },
]

export interface LiveTipsFilters {
  status: TipStatus | 'all'
  marketCategories: string[]
  minProbability: number
}

export const DEFAULT_FILTERS: LiveTipsFilters = {
  status: 'active',
  marketCategories: [],
  minProbability: 55,
}

interface LiveTipsFilterBarProps {
  filters: LiveTipsFilters
  onChange: (filters: LiveTipsFilters) => void
}

export function LiveTipsFilterBar({ filters, onChange }: LiveTipsFilterBarProps) {
  const handleFilterChange = <K extends keyof LiveTipsFilters>(
    key: K,
    value: LiveTipsFilters[K]
  ) => {
    onChange({ ...filters, [key]: value })
  }

  const toggleMarketCategory = (category: string) => {
    const updated = filters.marketCategories.includes(category)
      ? filters.marketCategories.filter((c) => c !== category)
      : [...filters.marketCategories, category]
    onChange({ ...filters, marketCategories: updated })
  }

  return (
    <div className="tips-filters">
      {/* Status Filter */}
      <div className="filter-group">
        <label className="filter-label">Status</label>
        <div className="filter-chips">
          {STATUS_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              className={`filter-chip ${filters.status === opt.value ? 'active' : ''}`}
              onClick={() => handleFilterChange('status', opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      {/* Market Category Filter */}
      <div className="filter-group">
        <label className="filter-label">Markets</label>
        <div className="filter-chips">
          {MARKET_CATEGORIES.map((cat) => (
            <button
              key={cat.value}
              className={`filter-chip ${filters.marketCategories.includes(cat.value) ? 'active' : ''}`}
              onClick={() => toggleMarketCategory(cat.value)}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {/* Min Probability Filter */}
      <div className="filter-group">
        <label className="filter-label">Min Probability</label>
        <div className="filter-chips">
          {MIN_PROBABILITY_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              className={`filter-chip ${filters.minProbability === opt.value ? 'active' : ''}`}
              onClick={() => handleFilterChange('minProbability', opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
